<template>
  <div>
    <!-- <div class="text-box-section mt-40">
      공고에 신청하기 전, 추가적으로 입력이 필요한 사항입니다.<br>
      <span class="must">*</span> 표시는 필수 입력 질문입니다.
    </div> -->
    <div class="form-section" v-if="checkListAnswers.length > 0">
      <h3 class="section-title">체크리스트</h3>
      <ul class="check-list">
        <li>
          <div class="tit">1. 현재 정부의 재정지원 직접일자리사업에 참여하고 있습니까?</div>
          <div class="radio-group">
            <label class="radio-item" for="checkQ1Y">
              <input type="radio" id="checkQ1Y" class="sr-only job-history-questions" data-seq="1" value="Y" v-model="(checkListAnswers[0] || {}).ANSWER" :disabled="isDisabled" title="checkQ1Y 선택">
              <span class="custom-radio"></span>
              예
            </label>
            <label class="radio-item" for="checkQ1N">
              <input type="radio" id="checkQ1N" class="sr-only job-history-questions" data-seq="1" value="N" v-model="(checkListAnswers[0] || {}).ANSWER" :disabled="isDisabled" title="checkQ1N 선택">
              <span class="custom-radio"></span>
              아니요
            </label>
          </div>
        </li>
        <li>
          <div class="tit">2. 현재 서울시 가치동행일자리 사업, 재단의 중장년 경력 인재 지원 사업에 참여하고 있습니까?</div>
          <div class="radio-group">
            <label class="radio-item" for="checkQ2Y">
              <input type="radio" id="checkQ2Y" class="sr-only job-history-questions" data-seq="2" value="Y" v-model="(checkListAnswers[1] || {}).ANSWER" :disabled="isDisabled" title="checkQ2Y 선택">
              <span class="custom-radio"></span>
              예
            </label>
            <label class="radio-item" for="checkQ2N">
              <input type="radio" id="checkQ2N" class="sr-only job-history-questions" data-seq="2" value="N" v-model="(checkListAnswers[1] || {}).ANSWER" :disabled="isDisabled" title="checkQ2N 선택">
              <span class="custom-radio"></span>
              아니요
            </label>
          </div>
        </li>
        <li>
          <div class="tit">3. 신청 예정인 활동처(기업,기관)에서 활동 또는 근무한 경험이 있습니까?</div>
          <div class="radio-group">
            <label class="radio-item" for="checkQ3Y">
              <input type="radio" id="checkQ3Y" class="sr-only job-history-questions" data-seq="3" value="Y" v-model="(checkListAnswers[2] || {}).ANSWER" :disabled="isDisabled" title="checkQ3Y 선택">
              <span class="custom-radio"></span>
              예
            </label>
            <label class="radio-item" for="checkQ3N">
              <input type="radio" id="checkQ3N" class="sr-only job-history-questions" data-seq="3" value="N" v-model="(checkListAnswers[2] || {}).ANSWER" :disabled="isDisabled" title="checkQ3N 선택">
              <span class="custom-radio"></span>
              아니요
            </label>
          </div>
        </li>
        <li class="sub-list">
          <div class="tit">(3)에서 "예" 라고 지원하는 경우 활동처명과 직책을 기재하여 주시기 바랍니다.</div>
          <div class="input-area">
            <span class="th-name">활동처명</span>
            <input type="text" class="short-input" placeholder="활동처명" title="활동처명" v-model="(checkListAnswers[2] || {}).DTL_ANSWER_1" :disabled="isDisabled">
            <span class="th-name">근무시 직책</span>
            <input type="text" class="short-input" placeholder="근무시 직책" title="근무시 직책" v-model="(checkListAnswers[2] || {}).DTL_ANSWER_2" :disabled="isDisabled">
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InSpecificFields',
  props: {
    checkListAnswers: {
      type: Array,
      default: () => []
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// InSpecificFields.vue?64e4c85a